export const wpUserDataLocal = { url: "", userId: "", token: "" };
